function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $31bda95942fa1698$exports = {};

$parcel$export($31bda95942fa1698$exports, "asyncBatch", () => $31bda95942fa1698$export$2f3768c184a3cc95);
async function $31bda95942fa1698$export$2f3768c184a3cc95(arr, callback, options = {}, event) {
    const { chunkSize: chunkSize = 10000, parallel: parallel = 1, debug: debug = false } = options;
    const chunks = Array.from({
        length: Math.ceil(arr.length / chunkSize)
    }, (_, i)=>arr.slice(i * chunkSize, i * chunkSize + chunkSize));
    if (debug) console.log(`${chunks.length} chunks to be processed`);
    const results = new Map();
    async function processChunk(chunkIndex, threadId) {
        if (debug) console.log(`Thread ${threadId} processing chunk ${chunkIndex}`);
        const result = await callback(chunks[chunkIndex], event);
        results.set(chunkIndex, result);
    }
    let currentIndex = 0;
    async function processChunks(threadId) {
        while(currentIndex < chunks.length){
            const chunkIndex = currentIndex++;
            await processChunk(chunkIndex, threadId);
        }
    }
    const promises = Array.from({
        length: parallel
    }, (_, i)=>processChunks(i));
    await Promise.all(promises);
    if (debug) console.log("All chunks processed");
    return Array.from(results.values());
}


var $fda4ce3509276b69$exports = {};

$parcel$export($fda4ce3509276b69$exports, "log", () => $fda4ce3509276b69$export$bef1f36f5486a6a3);
$parcel$export($fda4ce3509276b69$exports, "logInfo", () => $fda4ce3509276b69$export$89c0607256d35f0a);
$parcel$export($fda4ce3509276b69$exports, "logWarn", () => $fda4ce3509276b69$export$cc36178e946876e8);
$parcel$export($fda4ce3509276b69$exports, "logError", () => $fda4ce3509276b69$export$58da9968c3170cb1);
const $fda4ce3509276b69$export$bef1f36f5486a6a3 = (packageName, msg, type = "log")=>{
    const status = {
        log: "INFO",
        warn: "WARN",
        error: "FATAL"
    };
    console[type](`[${packageName}]:[${status[type]}] ${msg}`);
};
const $fda4ce3509276b69$export$89c0607256d35f0a = (packageName, msg)=>{
    $fda4ce3509276b69$export$bef1f36f5486a6a3(packageName, msg);
};
const $fda4ce3509276b69$export$cc36178e946876e8 = (packageName, msg)=>{
    $fda4ce3509276b69$export$bef1f36f5486a6a3(packageName, msg, "warn");
};
const $fda4ce3509276b69$export$58da9968c3170cb1 = (packageName, msg)=>{
    $fda4ce3509276b69$export$bef1f36f5486a6a3(packageName, msg, "error");
};




export {$31bda95942fa1698$export$2f3768c184a3cc95 as asyncBatch, $fda4ce3509276b69$export$bef1f36f5486a6a3 as log, $fda4ce3509276b69$export$89c0607256d35f0a as logInfo, $fda4ce3509276b69$export$cc36178e946876e8 as logWarn, $fda4ce3509276b69$export$58da9968c3170cb1 as logError};
//# sourceMappingURL=module.mjs.map
